import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lang: 'ja',
    query: {}
  },
  mutations: {
    init_query: function(state) {
      state.query = {
        keyword: '',
        name: '',
        operator: '',
        page: 1,
        size: 50,
        sort: '',
        org_lv1: '',
        org_lv2: '',
        area_lv1: '',
        area_lv2: '',
        job: ''
      };
    },
    save_query: function(state, params) {
      for (const name in params) {
        state.query[name] = params[name];
      }      
    },
    save_lang: function(state, lang) {
      state.lang = lang;
    }
  },
  actions: {
  },
  modules: {
  },
  plugins: [
    createPersistedState({
      key: 'rd.iai.osaka-u.ac.jp'
    })
  ]
})
